import m from "../../geodata/es2015/mexicoLow";
window.am4geodata_mexicoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/mexicoLow.js
// module id = null
// module chunks = 